import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "./Header";
import Sidebar from "./Sidebar";
import SubHeader from "./SubHeader";
import "../Style/Dashboard.css";
import "../Style/AssignRole.css";
import CreateAssignRole from "./CreateAssignRole";
import Role from './Role';
import { UserCog, Shield } from "lucide-react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const AssignRole = () => {
  const navigate = useNavigate();
  const [selectedRole, setSelectedRole] = useState("Assign Role");
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const handlePostClick = () => {
    navigate("/assign-role");
  };

  const handleRoleClick = (role) => () => {
    setSelectedRole(role);
    navigate(`/member-table/${encodeURIComponent(role)}`);
  };

  return (
    <div className="app-container">
      <Header toggleSidebar={toggleSidebar} />
      <ToastContainer position="top-right" autoClose={3000} />

      <div className="main-layout">
        <Sidebar isOpen={isSidebarOpen} onClose={() => setIsSidebarOpen(false)} />

        <main className="content-area">
          <SubHeader />

          <div className="assign-role-page">
            <aside className="roles-sidebar-modern">
              <div className="roles-header-modern">
                <Shield size={18} />
                <span style={{ color: "#007BFF" }}>Roles</span>
              </div>
              <div className="roles-list-modern">
                <Role setSelectedRole={setSelectedRole} />
              </div>
            </aside>

            <section className="assign-content-modern">
              <div className="assign-header-modern">
                <div className="assign-title-group">
                  <UserCog size={22} />
                 <h1 style={{ color: "#007BFF" }}>
                  {selectedRole}
                </h1>
                </div>
              </div>
              <div className="assign-body-modern">
                <CreateAssignRole />
              </div>
            </section>
          </div>
        </main>
      </div>
    </div>
  );
};

export default AssignRole;
